import { environment } from '../../../../../../environments/environment';
import { Shipping } from '../../../../../core';

const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
const currency = user ? user.user.currencyCode : '';
const textCurrency = `Precio /${currency}`;
export const exceptionalRate = {
  searchText: '',
  export: false,
  filter: false,
  checkbox: false,
  checkboxHeader: false,
  disabled: false,
  partialField: '',
  show: 'Listado de tarifas excepcionales',
  columns: [
    {
      title: 'Medida',
      name: 'rule',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Shipping) => {
        if (element.rule !== 'PER_WEIGHT_RULE') {
          return 'Unidad';
        } else {
          return 'Peso';
        }
      }
    },
    {
      title: textCurrency,
      name: 'costs',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Shipping) => {
        if (element.rule !== 'PER_WEIGHT_RULE') {
          return Number(element.costs[0].amount).toFixed(2);
        } else {
          return element.costs.map(item => item.amount).join('/');
        }
      }
    },
    {
      title: 'Activo',
      name: 'active',
      type: 'boolean',
      editable: true,
      checkAll: false,
      class: 'left',
      value: (element: any) => element.enabled
    }
  ]
};

